import styled from 'styled-components';
import RangeDetailGalleryStyles from '../RangeDetailGallery/RangeDetailGallery.styles';
const Container = styled.div ``;
const Inner = styled(RangeDetailGalleryStyles.Inner) ``;
export const MediaGalleryWidgetStyles = {
    Container,
    Inner,
};
